import { Injectable } from '@angular/core';
import { Router, Event as NavigationEvent, NavigationEnd, ChildActivationStart } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationRouteService {
  showCommonHeader$ = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    this._getNextRoute$();
  }

  private _getNextRoute$(): void {
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.enableCommonHeader(event.url);
      }
      if (event instanceof ChildActivationStart) {
        this.removeBackdropClassFromCwcPage();
      }
    });
  }

  private removeBackdropClassFromCwcPage(): void {
    const cwcPage = document.querySelector('cwc-page');
    if (cwcPage && cwcPage.shadowRoot) {
      const backdropEl = cwcPage.shadowRoot.querySelector('.cwc-page__menu--as-backdrop');
      if (backdropEl) {
        backdropEl.classList.remove('cwc-page__menu--as-backdrop');
      }
    }
  }

  public enableCommonHeader(url: string): void {
    const cleanUrl = url.split('?')[0].split('#')[0];
    const firstPath = cleanUrl.split('/').filter(Boolean)[0];
    if (COMMON_HEADER_PATHS.includes(firstPath)) {
      this.showCommonHeader$.next(true);
    }
  }
}

const COMMON_HEADER_PATHS = ['myaccount', 'billing', 'businessplans', 'checkout', 'home', 'permissions', 'users'];
